const controls = "_controls_17lij_8";
const styles = {
  controls,
  "button-group": "_button-group_17lij_18"
};
export {
  controls,
  styles as default
};
//# sourceMappingURL=EditInPlace.module.css.js.map
